import * as Sentry from '@sentry/react'
import axios from 'axios'
import { isProductionLikeEnvironment } from './runtime-environment'

const isAbortError = (error) =>
  axios.isCancel?.(error) ||
  error?.name === 'CanceledError' ||
  error?.name === 'AbortError' ||
  error?.code === 'ERR_CANCELED'

const UUID_PATTERN =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi

// Entity UUIDs in the URL would give every entity its own Sentry issue.
export const axiosFingerprint = (error, status) => [
  'axios',
  error?.config?.method,
  error?.config?.url?.replace(UUID_PATTERN, ':id'),
  String(status ?? 'network')
]

export const reportError = (error, { extra, tags, fingerprint } = {}) => {
  if (!isProductionLikeEnvironment) return
  if (!error || isAbortError(error)) return

  Sentry.captureException(error, {
    extra,
    tags,
    fingerprint
  })
}

export default reportError
